// Defects found on a condition visit (CONDITION-REPORTS.md "Defects"): who
// pays follows the cause, and a defect goes Open → Rectified → Verified (the
// API records when, and who verified). Pure rules; defects.ts saves.
import type { DeviceRecord } from './device-db';

export const DEFECT_CAUSES = ['Higgins workmanship', 'Caused by others', 'Pre-existing'] as const;
/** Only a defect caused by others is charged: a variation, or a back-charge to whoever caused it. */
export const CHARGE_ROUTES = ['Variation', 'Back-charge'] as const;
const NOT_CHARGEABLE = 'Not chargeable';
const CHARGED_CAUSE = 'Caused by others';

/** The charge route a cause starts with: ours or the client's own asset is not chargeable; others' waits for a choice. Pure. */
export const chargeRouteFor = (cause: string | null): string | null => (cause && cause !== CHARGED_CAUSE ? NOT_CHARGEABLE : null);

/** Whether a cause is charged to someone (so its charge route is chosen). Pure. */
export const isCharged = (cause: unknown): boolean => cause === CHARGED_CAUSE;

/** The next step for a defect at `status`, with its button's words; null once verified. Pure. */
export function nextDefectStep(status: unknown): { to: 'Rectified' | 'Verified'; label: string } | null {
  if (status === 'Rectified') return { to: 'Verified', label: 'Mark verified' };
  if (status === 'Verified') return null;
  return { to: 'Rectified', label: 'Mark rectified' };
}

/** A visit area's defects still on the visit (not taken off), oldest first by their order on the device. Pure. */
export function defectsOfVisitArea<T extends Pick<DeviceRecord, 'table' | 'fields'>>(records: readonly T[], visitAreaId: string | null): T[] {
  if (!visitAreaId) return [];
  return records.filter((r) => r.table === 'defect' && r.fields.hig_visitareaid === visitAreaId && r.fields.statecode !== 'Inactive');
}
